import { useGetAdminSettings } from '../../../../queries';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';
import * as yup from 'yup';
import { AdminSettingsResponse } from '../../../types';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { FormContent } from './components/FormContent';

const GROUP_NAME = 'tenant';

const schema = yup.object({
  tenant_name: yup.string(),
  tenant_timezone: yup.string(),
  tenant_language: yup.string(),
  tenant_s3bucketname: yup.string(),
  tenant_awsSecretKey: yup.string(),
  tenant_awsAccessKey: yup.string(),
  domain_redirect: yup.boolean(),
  tenant_loginbanner: yup.string(),
  tenant_internal_sdb_group_name: yup.string(),
  tenant_internal_sdb_group_number: yup.string(),
  informationcenter_bucket_name: yup.string(),
  informationcenter_bucket_accesskey: yup.string(),
  informationcenter_bucket_secretkey: yup.string()
});

const TenantSettings = () => {
  const { isFetching, data: tenantSettings = [] } =
    useGetAdminSettings<AdminSettingsResponse>(GROUP_NAME);

  const { isLoading, mutate: save } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: tenantSettings[0]?.groupId,
    invalidateQueryKey: [GROUP_NAME]
  });

  const settings = tenantSettings[0] ?? undefined;

  const onSubmit = (data) => {
    const payload = {
      ...settings,
      settings: transformAdminSettingsToRequestValues(data, settings?.settings)
    };
    save(payload);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={onSubmit}
      schema={schema}
      isFetching={isFetching}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(settings)}
    >
      <FormContent />
    </AdminSettingsFormWrapper>
  );
};

export default TenantSettings;
